export class Browser {
	static ToFormData(data) {
		const formData = new FormData();

		for (const key in data) {
			if (data[key] != null) {
				if (Array.isArray(data[key])) {
					if (data[key].length) {
						for (const value of data[key]) {
							formData.append(key, value);
						}
					}
				} else {
					formData.append(key, data[key]);
				}
			}
		}

		return formData;
	}

	static ResolveRelativeURL(url) {
		if (url.startsWith("~")) {
			return url.replace("~", location.origin);
		} else if (url.startsWith(".")) {
			return new URL(url, location).toString();
		} else {
			return url;
		}
	}

	static GetRouteID = (url) => parseInt(this.GetPaths(url).find(x => !isNaN(parseInt(x))));

	static SubmitSSO(clientID, email) {
		const form = document.createElementWithContents("form",
			`<input type="hidden"  name="client_id" value="${clientID}"/><input type="hidden" name="scope" value="openid User.Read profile email"/><input type="hidden" name="response_type" value="code"/><input type="hidden" name="redirect_uri" value="${window.location.origin}/oauth"/><input type="hidden" name="login_hint" value="${email}"/><input type="hidden" name="state" value="${this.GetURLParameter("ReturnUrl") ?? "/"}"/>`, {
			id: "frmSSOAgent",
			name: "frmSSOAgent",
			method: "post",
			target: "_self",
			action: "https://login.microsoftonline.com/chipside.onmicrosoft.com/oauth2/v2.0/authorize"
		});

		document.body.appendChild(form);
		form.submit();
	}

	static SetColourMode(theme, local) {
		if (theme.toLowerCase() !== "system") {
			document.documentElement.dataset.theme = theme;

			if (!local) {
				localStorage.setItem("site-theme", theme);
			}
		} else {
			document.documentElement.removeAttribute("data-theme");

			if (!local) {
				localStorage.removeItem("site-theme");
			}
		}

		Razor.InvokeThemeChange();
	}

	static ToggleColourMode(local) {
		this.SetColourMode(document.documentElement.dataset.theme === "dark" ? "light" : "dark", local);
	}

	static TryParseJSON(value) {
		let obj = value;

		try {
			obj = JSON.parse(value);
		} catch {
			// *twiddle thumbs*
		}

		return obj;
	}

	static GetPaths = (url) => new URL(url ?? window.location).pathname.split("/").filter(x => x?.trim() !== "");

	static GetCookie = name => `; ${document.cookie}`.split(`; ${name}=`).pop().split(";").shift();

	static AddMonths(date, amount) {
		date.setDate(1);
		date.setMonth(date.getMonth() + amount);
		date.setDate(Math.min(date.getDate(), this.#GetDaysInMonth(date.getFullYear(), date.getMonth())));

		return date;
	}

	static AddYears(date, amount) {
		date.setFullYear(date.getFullYear() + amount);

		return date;
	}

	static #GetDaysInMonth = (year, month) => [31, (this.#IsLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
	static #IsLeapYear = year => (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));

	static ShowNotification(title, options) {
		let defaultOptions = { icon: "/images/favicon.ico" };

		function handleNotification() {
			navigator.serviceWorker.ready.then(reg => {
				reg.getNotifications().then(notifications => {
					if (!notifications.find(x => x.tag === options.tag)) {
						reg.showNotification(title, Object.assign(defaultOptions, options))
					}
				});
			});
		}

		if (Notification.permission === "granted") {
			handleNotification();
		} else if (Notification.permission !== "denied") {
			Notification.requestPermission().then(permission => {
				if (permission === "granted") {
					handleNotification();
				}
			});
		}

	}

	static GetURLParameters = parameter => new URLSearchParams(location.search).getAll(parameter);
	static GetURLParameter = parameter => this.GetURLParameters(parameter).at(0);

	static SetURLParameters(parameters, ignoreIdentical) {
		const params = new URLSearchParams(location.search);

		if (parameters) {
			Object.keys(parameters).forEach(key => {
				const value = parameters[key];

				if (value == null || (Array.isArray(value) && !value.length)) {
					params.delete(key);
				} else {
					const all = params.getAll(key).map(String);

					if (Array.isArray(value)) {
						value.filter(x => !all.includes(x.toString())).forEach(x => params.append(key, x));
					} else if (!all.includes(value.toString())) {
						params.set(key, value);
					}
				}
			});

			const newValue = params.toString(),
				newUrl = `${location.pathname}${newValue !== '' ? '?' + newValue : ''}`;

			if (newUrl === location.pathname + location.search && ignoreIdentical) { return false; }

			location.href = newUrl;

			return true;
		}

		return false;
	}

	static SetURLParameter = (name, value, ignoreIdentical) => this.SetURLParameters({ [name]: value }, ignoreIdentical);

	static ListenForShortcut(key, modifiers, callback, ignoreInputs) {
		if (typeof modifiers === "string") {
			modifiers = [modifiers];
		}

		if (typeof callback !== "function") { return; }

		window.addEventListener("keydown", event => {
			if (ignoreInputs && (event.target ?? event.relatedTarget)?.closest("input, textarea")) { return; }

			if (event.key.toUpperCase() === key.toUpperCase() && !document.querySelector(".modal.show")) {
				if (modifiers.length) {
					const modifierChecker = {
						CTRL: event.ctrlKey,
						ALT: event.altKey,
						SHIFT: event.shiftKey,
						META: event.metaKey
					}

					if (modifierChecker && !modifiers.find(x => !modifierChecker[x])) {
						const keys = Object.keys(modifierChecker);

						if (keys && !keys.filter(x => !modifiers.includes(x)).find(x => !!modifierChecker[x])) {
							event.preventDefault();
							callback(event);
						}
					}
				} else {
					event.preventDefault();
					callback(event);
				}
			}
		});
	}
}